var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDounArro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.343186 1.24354C-0.0473381 1.63406 -0.0473381 2.26723 0.343186 2.65775L5.29293 7.6075C5.68346 7.99802 6.31662 7.99802 6.70715 7.6075L11.6569 2.65775C12.0474 2.26723 12.0474 1.63406 11.6569 1.24354C11.2664 0.853012 10.6332 0.853012 10.2427 1.24354L6.00004 5.48618L1.7574 1.24354C1.36688 0.853012 0.73371 0.853012 0.343186 1.24354Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDounArro);
export default __webpack_public_path__ + "static/media/time-doun-arro.edb81107c2ddefd2743d36746484f6c9.svg";
export { ForwardRef as ReactComponent };